<template>
  <div class="modal-dim on">
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="et-modal">
          <!-- 헤더: 제목 + 닫기 -->
          <div class="et-head">
            <h2 class="et-title">{{ title }}</h2>
            <button type="button" class="et-close" @click="cancel" aria-label="닫기">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M5 5 L15 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                <path d="M15 5 L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              </svg>
            </button>
          </div>

          <div class="et-divider"></div>

          <!-- 본문 -->
          <p class="et-body">{{ body }}</p>

          <!-- 구매 / 취소 -->
          <button type="button" class="et-cta" @click="confirm">{{ doneText }}</button>
          <button type="button" class="et-cancel" @click="cancel">{{ cancelText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

// RegisterDoneModal 그린 카드 패턴 재사용(2버튼: 구매/취소). 디자인 "이벤트 알림" 모달.
const props = defineProps(['data']);
const emits = defineEmits(['close']);

const title = computed(() => props.data?.title || '이벤트 알림');
const body = computed(() => props.data?.body || '이벤트 알림권이 부족합니다.\n추가 구매하시겠어요?');
const doneText = computed(() => props.data?.doneText || '구매');
const cancelText = computed(() => props.data?.cancelText || '취소');

const confirm = () => {
  const cb = props.data?.doneCallback;
  emits('close');
  // 모달 닫힘 후 다음 모달(구매 플로우)이 겹치지 않게 한 틱 뒤 콜백
  if (cb) setTimeout(() => cb(), 150);
};

const cancel = () => {
  const cb = props.data?.cancelCallback;
  emits('close');
  if (cb) setTimeout(() => cb(), 150);
};
</script>

<style scoped lang="scss">
$g: #30CA22;

.modal-dim.on {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}
.modal-inner.center {
  width: 100%;
  max-width: 375px;
  padding: 0 16px;
}

.et-modal {
  background: #ffffff;
  border-radius: 14px;
  padding: 30px 20px;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.et-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.et-title {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #000000;
  margin: 0;
}
.et-close {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border: 0;
  background: transparent;
  color: #000000;
  cursor: pointer;
  padding: 0;
}
.et-close svg {
  width: 20px;
  height: 20px;
}

.et-divider {
  height: 1px;
  background: #cacaca;
  margin: 14px 0;
}

.et-body {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.03em;
  color: #000000;
  white-space: pre-line;
  margin: 0 0 14px;
}

.et-cta {
  width: 100%;
  height: 50px;
  border: 0;
  border-radius: 10px;
  background: $g;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.3px;
  cursor: pointer;
}
.et-cta:active {
  background: #27a91c;
}

.et-cancel {
  width: 100%;
  margin-top: 14px;
  border: 0;
  background: transparent;
  color: #959595;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.3px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
